<template>
  <div class="resource_download">
    <div class="nav-header">
      <NavHeader
        :status="{
          page: 'download',
          produce: false,
          solution: false,
        }"
      />
    </div>

    <div class="banner" style="overflow: hidden">
      <div class="banner-img">
        <div class="banner-img-box">
          <div class="banner-img-imac"></div>
          <div class="banner-img-notebook"></div>
          <div class="banner-img-iPad"></div>
          <div class="banner-img-photo"></div>
        </div>
        <!-- 这是字 -->
      </div>
      <div class="banner-img-text">
        <div class="banner-img-text-a" style="height: 50%">
          多版本适配，应用场景更加广泛
        </div>
        <div class="banner-img-text-b" style="height: 50%">随时随地练习实验</div>
      </div>
    </div>
    <div class="bg-img"></div>
    <div class="main_contents">
      <!-- 下载软件 -->
      <div class="download-software" v-if="softwareShow">
        <div class="download-left">
          <div class="download-back">
            <div class="download-line" style="margin-top: 5vw">
              <div class="wx_btn_icon"></div>
              <div class="download_font">微信小程序（{{version_wx}}）</div>
              <div
                class="update-info"
                style="cursor: pointer; margin-left: 4vw; margin-right: 3vw"
                @click="openUpdateLog('wxmp')"
              >
                更新日志
              </div>
              <el-popover placement="top-start" trigger="hover">
                <div class="qrcode"></div>
                <div slot="reference" class="download-btn">
                  <div>扫描二维码</div>
                  <div class="download-btn-img"></div>
                </div>
              </el-popover>
            </div>
            <div class="download-line" style="margin-top: 4vw">
              <div class="windows_icon"></div>
              <div class="download_font">Windows（{{version_pc}}）</div>
              <div
                class="update-info"
                style="cursor: pointer; margin-left: 5vw; margin-right: 3vw"
                @click="openUpdateLog('pc')"
              >
                更新日志
              </div>
              <div
                class="download-btn"
                style="background-color: #24c3ff"
                @click="dloadWindows"
              >
                <div style="white-space: nowrap">下载Windows</div>
                <div class="download-btn-img download-icon"></div>
              </div>
            </div>
            <div class="download-line" style="margin-top: 4vw">
              <div class="windows_icon"></div>
              <div class="download_font">翼渡课堂&nbsp;（{{ydkt_version_pc}}）</div>
              <div
                class="update-info"
                style="cursor: pointer; margin-left: 5vw; margin-right: 3vw"
                @click="openUpdateLog('ydkt-pc')"
              >
                更新日志
              </div>
              <div
                class="download-btn"
                style="background-color: #24c3ff"
                @click="dloadYDKTWindows"
              >
                <div style="white-space: nowrap">下载Windows</div>
                <div class="download-btn-img download-icon"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="download-iphone"></div>
      </div>
      <!-- /下载软件 -->

      <!-- 下载客户端 -->
      <div class="download-client" v-if="clientShow">
        <div class="client-title"></div>
        <div class="client-main">
          <div class="client-box-text">
            <div class="client-box-img"></div>
            <div
              class="client-btn"
              @click="downloadOnline"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
              "
            >
              <div>下载Windows</div>
              <div class="download-btn-img download-icon"></div>
            </div>
          </div>
          <div class="client-box-text1">
            <div class="client-box-img1"></div>
            <div
              class="client-btn"
              @click="downloadExam"
              style="
                background-color: #ffbc64;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
              "
            >
              <div>下载Windows</div>
              <div class="download-btn-img download-icon"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- /下载客户端 -->

      <!-- 黑板 -->
      <div class="blackboard" v-if="clientShow"></div>
    </div>

    <div class="footer-img">
      <div
        style="
          font-family: test;
          font-size: 1.2vw;
          color: white;
          font-weight: 100;
          cursor: default;
        "
      >
        让我们一起育见未来
      </div>
      <div class="footer-btn-group">
        <div class="footer-btn">立即试用</div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import NavHeader from "@/components/NavHeader";
import {
  getPCDownLoadInfo,
  getXYJFDownloadURL,
  getXYYTJDownloadURL,
  getWXDownLoadInfo,
  getYDKTDownloadURL
} from "../api/app.js";
import $ from "jquery";
export default {
  name: "download",
  components: {
    Footer,
    NavHeader,
  },
  data() {
    return {
      version_wx:'',
      version_pc:'',
      softwareShow: true,
      clientShow: true,
      downloadUrl_pc: "",
      download_xyytj:'',
      downloadUrl_xyjf: "",
      ydkt_version_pc:'',
      ydkt_download_url:''
    };
  },
  mounted() {
    getXYJFDownloadURL(location.protocol).then((res) => {
      this.downloadUrl_xyjf = res.data.url;

    }).catch(e =>{

    })
    getYDKTDownloadURL(location.protocol).then((res) => {
      this.ydkt_download_url = res.data.url;
      this.ydkt_version_pc = res.data.version.split(' ')[0]
    }).catch(e =>{

    })
    getXYYTJDownloadURL(location.protocol).then((res) => {
      this.download_xyytj = res.data.url;
    }).catch(e =>{

    })
    this.getDownLoadInfo();
    $(".banner-img-text").animate(
      {
        opacity: "1",
        bottom: "12vw",
      },
      1000
    );
    $(".banner-img-imac").animate(
      {
        opacity: "1",
        left: "16vw",
        top: "0",
      },
      1000
    );
    $(".banner-img-iPad").animate(
      {
        opacity: "1",
        top: "15.5vw",
        right: "5vw",
      },
      1000
    );
    $(".banner-img-notebook").animate(
      {
        opacity: "1",
        top: "13vw",
        left: "2vw",
      },
      1000
    );
    $(".banner-img-photo").animate(
      {
        opacity: "1",
        top: "18vw",
        right: "10vw",
      },
      1000
    );
  },
  methods: {
    getDownLoadInfo() {
      console.log(location);

      getPCDownLoadInfo(location.protocol)
        .then((res) => {
          console.log("下载信息", res);
          if (res.code == 200) {
            this.downloadUrl_pc = res.data.url;
            this.version_pc = res.data.version.split(' ')[0]
          } else {
            this.$message.error("获取windows下载地址失败");
          }
        })
        .catch((res) => {
          this.$message.error("获取下载信息失败，请检查网络");
        });

      getWXDownLoadInfo(location.protocol)
        .then((res) => {
          console.log("下载信息微信", res);
          if (res.code == 200) {
            // this.downloadUrl_pc = res.data.url;
            this.version_wx = res.data.version.split(' ')[0]
          } else {
            this.$message.error("获取微信下载地址失败");
          }
        })
        .catch((res) => {
          this.$message.error("获取下载信息失败，请检查网络");
        });

    },
    openUpdateLog(data) {
      this.$router.push({
        path: "/update-log",
        query: {
          type: data,
        },
      });
    },
    dloadWindows() {
      const a = document.createElement("a");
      a.href = this.downloadUrl_pc;
      if(this.downloadUrl_pc.indexOf('http')===-1){
        this.$message.error("获取下载地址失败");
      }
      else{
        a.click();
      }
    },
    dloadYDKTWindows(){
      const a = document.createElement("a");
      a.href = this.ydkt_download_url;
      if(this.ydkt_download_url.indexOf('http')===-1){
        this.$message.error("获取下载地址失败");
      }
      else{
        a.click();
      }
    },
    dloadAndroid() {
      console.log("下载Android");
    },
    dloadIOS() {
      console.log("下载IOS");
    },
    downloadExam() {
      const a = document.createElement("a");
      a.href = this.downloadUrl_xyjf;
      if(this.downloadUrl_xyjf.indexOf('http')===-1){
        this.$message.error("获取下载地址失败");
      }
      else{
        a.click();
      }

    },
    downloadOnline() {

      const a = document.createElement("a");
      a.href =this.download_xyytj
      if(this.download_xyytj.indexOf('http')===-1){
        this.$message.error("获取下载地址失败");
      }
      else{
        a.click();
      }

    },
  },
};
</script>

<style>
.resource_download {
  width: 100vw;
  overflow: hidden;
}
.nav-header {
  width: 100vw;
  height: 4vw;
}
.banner-img-box {
  width: 60vw;
  height: 28vw;
  margin: auto;
  position: relative;
}
.banner {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100vw;
  height: 51vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/banner.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.banner-img {
  width: 60vw;
  margin: 4vw auto 2vw;
  height: 30vw;
}
.banner-img-imac {
  position: absolute;
  top: -10vw;
  opacity: 0;
  left: 16vw;
  width: 28vw;
  height: 24vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/iMac.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* margin: 0 auto; */
}
.banner-img-notebook {
  position: absolute;
  top: 13vw;
  left: -5vw;
  opacity: 0;
  width: 28vw;
  height: 15vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/笔记本电脑.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.banner-img-iPad {
  position: absolute;
  top: 15.5vw;
  right: -10vw;
  width: 29vw;
  height: 12vw;
  opacity: 0;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/iPad.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.banner-img-photo {
  position: absolute;
  top: 27vw;
  right: 5vw;
  opacity: 0;
  width: 5vw;
  height: 9.35vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/手机.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.banner-img-text {
  opacity: 0;
  width: 30vw;
  top: 40vw;
  margin-left: 35vw;
  height: 10vh;
  font-family: test;
  font-size: 2vw;
  font-weight: bold;
  font-stretch: normal;
  line-height: 1.5vw;
  text-align: center;
  letter-spacing: 2px;
  color: #f9faff;
  position: absolute;
}
.main_contents {
  /* background-color: #f9faff; */
}
.download-software {
  position: relative;
  width: 86vw;
  height: 40vw;
  margin-top: 3vw;
  margin-left: 7vw;
  margin-right: 3vw;
}
.download-left {
  width: 35vw;
  height: 40vw;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url("http://data.xiyilab.com/web/main/static/download/蜥翼虚拟仿真实验室.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.download-back {
  margin-top: 15vw;
  width: 35vw;
  height: 20vw;
  /* background-image: url("http://data.xiyilab.com/web/main/static/download/微信 Windows.png"); */
  /* background-repeat: no-repeat; */
  /* background-size: contain; */
  /* background-position: center; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}
.download-line {
  width: 100%;
  height: 3vw;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  border-bottom: 1px dashed #666;
  color: #666;
}
.wx_btn_icon{
    width: 3vw;
    height: 3vw;
    background-image: url("http://data.xiyilab.com/web/main/static/资源下载/微信.png");
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 1vw;
}
.windows_icon{
    width: 2.5vw;
    height: 2.5vw;
    background-image: url("http://data.xiyilab.com/web/main/static/资源下载/windows.png");
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 1vw;
}
.download_font{
    font-size: 20px;
}
.exp-operation-title {
  width: 40vw;
  height: 4vw;
  line-height: 4vw;
  font-family: test;
  font-size: 2.5vw;
  font-weight: bold;
  font-stretch: normal;
  color: #3e3a39;
}

.line {
  width: 12vw;
  height: 0.4vw;
  background-image: linear-gradient(90deg, #04abff 0%, #4f75fb 100%);
}
.line-outside-color,
.line {
  display: inline-block;
}
.line-outside-color {
  width: 0.5vw;
  height: 0.4vw;
  box-sizing: border-box;
}
.line-color {
  width: 10px;
  height: 4px;
  box-sizing: border-box;
  margin-top: 2px;
  /* background-color: red; */
}
.describe-text {
  width: 100%;
  height: 1.4vw;
  font-family: test;
  font-size: 1.2vw;
  line-height: 1.4vw;
  letter-spacing: 0px;
  color: #666666;
  margin-top: 1.5vw;
}
.download-zone {
  position: relative;
  width: 35vw;
  height: 30vw;
  margin-top: 4vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/图层27.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-color: black;
}
.download-btn {
  cursor: pointer;
  width: 8vw;
  height: 2vw;
  box-shadow: 0vw 0vw 0vw 0vw rgba(160, 160, 160, 0.5);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-around;
  font-size: 0.9vw;
  line-height: 1vw;
  letter-spacing: 0vw;
  color: #ffffff;
  background-color: #81e765;
}
.download-btn:active {
  transform: translate(2px, 2px);
}
.download-btn-img {
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/二维码.png");
  width: 1vw;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.download-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/下载.png");
}
.download-iphone {
  position: absolute;
  top: 3vw;
  right: -4vw;
  width: 48vw;
  height: 35vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/iPhones.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.download-client {
  width: 73vw;
  height: 29vw;
  margin-left: 10vw;
  margin-top: 10vw;
  box-sizing: border-box;
}
.client-title {
  width: 25vw;
  height: 6vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/客户端标题.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.client-main {
  display: flex;
  width: 73vw;
  height: 15vw;
  margin-top: 2vw;
  margin-left: 3.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/客户端模块背景.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.client-box-text,
.client-box-text1 {
  width: 30%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.client-box-img {
  width: 100%;
  height: 3.8vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/蜥翼初中理化生虚拟仿真实验同步教学.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.client-box-img1 {
  width: 100%;
  height: 3.8vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/蜥翼初中理化生虚拟仿真实验模拟训练.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.client-btn1,
.client-btn {
  position: relative;
  width: 160px;
  height: 41px;
  line-height: 41px;
  margin-top: 68px;

  font-family: test;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #ffffff;
  background-color: #6dc555;

  box-shadow: 0px 1px 4px 0px rgba(160, 160, 160, 0.5);
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 14px;
  cursor: pointer;
}
.client-btn:active {
  transform: translate(2px, 2px);
}
.blackboard {
  width: 73vw;
  height: 24vw;
  margin-top: -2vw;
  margin-left: 13.5vw;
  margin-bottom: 6vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/图层28.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.footer-btn {
  width: 120px;
  height: 36px;
  background-color: transparent;
  border: solid 1px #f0f3fd;
  font-family: test;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 36px;
  letter-spacing: 1px;
  color: #ffffff;
  text-align: center;
}
.footer-img {
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group {
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn {
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  height: 2vw;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height: 2vw;
  text-align: center;
  cursor: pointer;
}
.bg-img {
  width: calc(100vw - 17px);
  overflow: hidden;
  height: 60vw;
  margin-top: -10vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/蓝色bg.png");
  background-color: rgb(249, 250, 255);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  position: absolute;
  z-index: -1;
}
.qrcode {
  width: 10vw;
  height: 10vw;
  margin: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url("http://data.xiyilab.com/web/main/static/qrcode.png");
}
.update-info {
  font-size: 1.2vw;
  color: rgb(36, 138, 255);
  text-decoration: underline;
  font-weight: bold;
  font-family: test;
}
</style>
